import { Dto } from './dto.model';
import { Status } from '../../enums/status.enum';

/**
 * A DTO class to use if a controller returns a single item
 */
export class ItemDto<T> extends Dto {
  /**
   * @param code - The DTO's status code
   * @param data - The DTO's data
   */
  constructor(code: Status, public data: T) {
    super(code);
  }
}
